module.exports = __webpack_public_path__ + "img/1280x720-Classroom.836a465d.jpg";